import { get } from 'lodash-es';

import { STATUS_LOADING, STATUS_SUCCESS, STATUS_ERROR } from 'store/status';

import { CREATE_DRAFT, GET_BOOK_BY_ID } from 'modules/v2/editor/store/constants';
import { book as initialState } from 'modules/v2/editor/store/reducers/initialState';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${CREATE_DRAFT}_REQUESTED`:
    case `${GET_BOOK_BY_ID}_REQUESTED`: {
      return {
        ...state,
        data: null,
        status: STATUS_LOADING,
      };
    }

    case `${CREATE_DRAFT}_FAILED`:
    case `${GET_BOOK_BY_ID}_FAILED`: {
      return {
        ...state,
        status: STATUS_ERROR,
      };
    }

    case `${CREATE_DRAFT}_SUCCEEDED`: {
      return {
        ...state,
        status: STATUS_SUCCESS,
      };
    }

    case `${GET_BOOK_BY_ID}_SUCCEEDED`: {
      const data = get(action, ['payload', 'book'], null);

      return {
        ...state,
        data,
        status: STATUS_SUCCESS,
      };
    }

    default:
      return state;
  }
};

export default reducer;
